// @flow
import React, { Component } from 'react';
import { MenuBig } from './MenuBig';
import { MenuSmall } from './MenuSmall';
import { IsLargeScreen } from '../Media';

type Props = {
  menuData: MenuStructure,
};

export type MenuStructure = {
  menuContent: Array<MenuContent>,
};

type MenuContent = {
  menuItemTitle: string,
  menuItems: Array<MenuItem>,
};

type MenuItem = {
  title: string,
  links: Array<LinkObj>,
};

type LinkObj = {
  linkTitle: string,
  url: string,
};

export class Menu extends Component<Props> {
  render() {
    return (
      <IsLargeScreen>
        {(match) =>
          match ? (
            <MenuBig menuData={this.props.menuData} />
          ) : (
            <MenuSmall menuData={this.props.menuData} />
          )
        }
      </IsLargeScreen>
    );
  }
}

export default Menu;
